<template>
  <div class="collection-showcase">
    <div class="collection-showcase__column" data-scroll-scale="1">
      <div
        class="collection-showcase__bottle-wrapper"
        data-in-out
        data-in-out-animation="slide"
        data-in-delay="0.4"
      >
        <ShowcaseBottle
          :color="'black'"
          :name="'<div class=\'stagger\'>Cuvée</div><div class=\'stagger\'>1821</div>'"
          :to="'/collection/cuvee-1821'"
          :image="'/static/bottles/cuvee-1821/preview.jpg'"
          :imageHover="'/static/bottles/cuvee-1821/preview_hover.jpg'"
        />
      </div>
      <div
        class="collection-showcase__bottle-wrapper"
        data-in-out
        data-in-out-animation="slide"
        data-in-delay="0.4"
      >
        <ShowcaseBottle
          :color="'grey'"
          :name="'<div class=\'stagger\'>Prestige</div><div class=\'stagger\'>1821</div>'"
          :to="'/collection/prestige-1821'"
          :image="'/static/bottles/prestige-1821/preview.jpg'"
          :imageHover="'/static/bottles/prestige-1821/preview_hover.jpg'"
        />
      </div>
      <div
        class="collection-showcase__bottle-wrapper"
        data-in-out
        data-in-out-animation="slide"
        data-in-delay="0.4"
      >
        <!-- <ShowcaseBottle
          :color="'grey'"
          :name="'<div class=\'stagger\'>Special Cuvée</div><div class=\'stagger\'>Millesimato</div>'"
          :to="'/collection/special-cuvee-millesimato'"
          :image="'/static/bottles/special-cuvee-millesimato/preview.jpg'"
          :imageHover="'/static/bottles/special-cuvee-millesimato/preview_hover.jpg'"
        /> -->
      </div>
    </div>
    <div class="collection-showcase__column" data-scroll-scale="1.2">
      <div
        class="collection-showcase__bottle-wrapper"
        data-in-out
        data-in-out-animation="slide"
        data-in-delay="0.4"
      >
        <ShowcaseBottle
          :color="'black'"
          :name="'<div class=\'stagger\'>Rosé</div><div class=\'stagger\'>1821</div>'"
          :to="'/collection/rose-1821'"
          :image="'/static/bottles/rose-1821/preview.jpg'"
          :imageHover="'/static/bottles/rose-1821/preview_hover.jpg'"
        />
      </div>
      <div
        class="collection-showcase__bottle-wrapper"
        data-in-out
        data-in-out-animation="slide"
        data-in-delay="0.4"
      >
        <ShowcaseBottle
          :color="'grey'"
          :name="'<div class=\'stagger\'>Collezione Leone</div><div class=\'stagger\'>Prosecco</div>'"
          :to="'/collection/collezione-leone-prosecco-doc'"
          :image="`/static/bottles/collezione-leone-prosecco-doc/preview-${$store.state.lang}.jpg`"
          :imageHover="`/static/bottles/collezione-leone-prosecco-doc/preview_hover-${$store.state.lang}.jpg`"
        />
      </div>
      <div
        class="collection-showcase__bottle-wrapper"
        data-in-out
        data-in-out-animation="slide"
        data-in-delay="0.4"
      >
        <!-- <ShowcaseBottle
          :color="'grey'"
          :name="'<div class=\'stagger\'>Special Cuvée</div><div class=\'stagger\'>Millesimato</div>'"
          :to="'/collection/special-cuvee-millesimato'"
          :image="'/static/bottles/special-cuvee-millesimato/preview.jpg'"
          :imageHover="'/static/bottles/special-cuvee-millesimato/preview_hover.jpg'"
        /> -->
      </div>
    </div>
    <div class="collection-showcase__column" data-scroll-scale="1.1">
      <div
        class="collection-showcase__bottle-wrapper"
        data-in-out
        data-in-out-animation="slide"
        data-in-delay="0.4"
      >
        <ShowcaseBottle
          :color="'grey'"
          :name="'<div class=\'stagger\'>Special Cuvée</div><div class=\'stagger\'>Millesimato</div>'"
          :to="'/collection/special-cuvee-millesimato'"
          :image="'/static/bottles/special-cuvee-millesimato/preview.jpg'"
          :imageHover="'/static/bottles/special-cuvee-millesimato/preview_hover.jpg'"
        />
      </div>
      <div
        class="collection-showcase__bottle-wrapper"
        data-in-out
        data-in-out-animation="slide"
        data-in-delay="0.4"
      >
        <ShowcaseBottle
          :color="'grey'"
          :name="'<div class=\'stagger\'>Collezione Leone</div><div class=\'stagger\'>Prosecco Rosé</div>'"
          :to="'/collection/collezione-leone-prosecco-doc-rose'"
          :image="'/static/bottles/collezione-leone-prosecco-doc-rose/preview.jpg'"
          :imageHover="'/static/bottles/collezione-leone-prosecco-doc-rose/preview_hover.jpg'"
        />
      </div>
      <div
        class="collection-showcase__bottle-wrapper"
        data-in-out
        data-in-out-animation="slide"
        data-in-delay="0.4"
      >
        <!-- <ShowcaseBottle :color="'white'" :name="''" /> -->
      </div>
    </div>
  </div>
</template>

<script>
import engine from '@/scripts/engine';
import scroll from '@/scripts/scroll';
import ShowcaseBottle from '@/components/contents/ShowcaseBottle.vue';
import { isMobile } from '../../scripts/utils';

export default {
  name: 'CollectionShowcase',

  components: {
    ShowcaseBottle,
  },

  mounted() {
    engine.add(this.scroll, 'showcase-scroll');
    this.$nextTick(() => scroll.setBoundries(this.$el));
  },

  methods: {
    scroll() {
      scroll.checkIsScrolled();
      if (!isMobile()) {
        const columns = Array.from(this.$el.querySelectorAll('.collection-showcase__column'));
        columns.forEach((column) => {
          column.style.transform = `translateY(-${scroll.ref.amount.y * column.dataset.scrollScale}px)`;
        });
      } else {
        const columns = Array.from(this.$el.querySelectorAll('.collection-showcase__column'));
        columns.forEach((column) => {
          column.style.transform = `translateY(-${scroll.ref.amount.y}px)`;
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.collection-showcase {
  padding-top: 80vh;
  padding-top: calc(var(--vh, 1vh) * 80);
  padding-left: calc((100vw / 32) * 4);
  padding-right: calc((100vw / 32) * 4);

  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  @include mq($until: ipadL) {
    padding-top: calc(var(--vh, 1vh) * 60);
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
  }

  &__column {
    flex-basis: 33.33%;
    display: flex;
    flex-direction: column;
    justify-content: center;

    @include mq($until: ipadL) {
      flex-basis: 100%;
      flex-wrap: wrap;
    }
  }

  &__bottle-wrapper {
    @include mq($until: ipadL) {
      .showcase-bottle {
        width: calc(219px * var(--rw));
        height: calc(780px * var(--rw));
      }
    }
  }
}
</style>
